// libs
import React from "react";

const Noop: React.FC = () => {
    return <></>;
};

export default React.memo(Noop);
